import config from '../config';
import axios from 'axios';
import decode from 'jwt-decode';
import router from '../router';

export default {
  namespaced: true,
  state: {
    isFetching: false,
    errorMessage: '',
    currentUser: null,
  },
  mutations: {
    LOGIN_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
      state.currentUser = null;
    },
    LOGIN_SUCCESS(state, user) {
      //ลงชื่อเข้าใช้สำเร็จ

      state.isFetching = false;
      state.errorMessage = '';
      state.currentUser = user || null;
    },
    LOGIN_REQUEST(state) {
      state.isFetching = true;
    },
  },
  actions: {
    async findMe({ dispatch }, guard = 'user') {

      try {
        const url = guard === 'user' ? '/auth/me' : '/equipment/auth/me';
        const storageKey = guard === 'user' ? 'user_data' : 'equipment_user_data';
        const response = await axios.get(url);

        // Add data to localStorage
        localStorage.setItem(storageKey, JSON.stringify(response.data));

        return response.data;

      } catch (e) {
        dispatch('snackbar/showSnackbar', e, { root: true });
        dispatch('logoutUser');
      }
    },

    async doInit({ dispatch, commit }) {
      try {

        //console.log('doInit')
        let currentUser = null;

        let token = localStorage.getItem('token');
        let equipmentToken = localStorage.getItem('equipment_token');

        if (token!=null) {
          currentUser = await dispatch('findMe', 'user');
        }
        else if (equipmentToken!=null) {
          currentUser = await dispatch('findMe', 'equipment_user');
        }

        commit('LOGIN_SUCCESS', currentUser);
      } catch (e) {
        commit('LOGIN_FAILURE', e);
      }
    },

    async loginUser({ dispatch }, payload) {
      dispatch('requestLogin');

      if (payload.social) {
        window.location.href =
            config.baseURLApi + '/auth/signin/' + payload.social+'?redirect='+payload.redirect;
      }
      else if (payload.email && payload.password) {
        try {
          const res = await axios.post('/auth/signin/local', payload);
          const token = res.data;
          dispatch('receiveToken', { token, guard: 'user' });
          dispatch('doInit');
        } catch (e) {
          dispatch('snackbar/showSnackbar', e, { root: true });
          dispatch('loginError', e.response.data);
        }
      } else {
        dispatch('loginError', 'Something was wrong. Try again');
      }
    },

    async loginEquipmentUser({ dispatch }, payload) {
      dispatch('requestLogin');

     // console.log('loginEquipmentUser')


      if (payload.social) {
        window.location.href =
            config.baseURLApi + '/equipment/auth/signin/' + payload.social+'?redirect='+payload.redirect;
      }
      else if (payload.email && payload.password) {
        try {
          const res = await axios.post('/equipment/auth/signin/local', payload);
          const token = res.data;
          dispatch('receiveToken', { token, guard: 'equipment_user' });
          dispatch('doInit');
        } catch (e) {
          dispatch('snackbar/showSnackbar', e, { root: true });
          dispatch('loginError', e.response.data);
        }
      } else {
        dispatch('loginError', 'Something was wrong. Try again');
      }
    },

    receiveToken({ commit, dispatch }, { token, guard = 'user' }) {

     // console.log('receiveToken')

      let user = decode(token);

      const storageKey = guard === 'user' ? 'token' : 'equipment_token';
      const userKey = guard === 'user' ? 'user' : 'equipment_user';

      localStorage.setItem(storageKey, token);
      localStorage.setItem(userKey, JSON.stringify(user));

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

      commit('LOGIN_SUCCESS', user);

      // เรียก doInit หลังจากรับ token สำเร็จ * ไม่งั้น user จะไม่ได้ Map ข้อมูล
      dispatch('doInit');

      /*const urlPage = guard === 'user' ? '/' : '/erbr/equipment-profile-view';
      router.push(urlPage);*/

      // ✅ ดึง path ที่เก็บไว้ก่อน login (เช่น /web/content_work)
      const redirectPath = localStorage.getItem('redirectAfterLogin');
      if (redirectPath) {
        localStorage.removeItem('redirectAfterLogin');
        router.push(redirectPath);
      } else {
        // ✅ fallback ไปหน้า default ถ้าไม่มี path เดิม
        const urlPage = guard === 'user' ? '/' : '/erbr/equipment-profile-view';
        router.push(urlPage);
      }

    },

    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('equipment_token');
      localStorage.removeItem('user');
      localStorage.removeItem('user_data');
      localStorage.removeItem('equipment_user_data');
      axios.defaults.headers.common['Authorization'] = '';
      router.push('/login');
    },

    loginError({ commit }, payload) {
      commit('LOGIN_FAILURE', payload);
    },

    requestLogin({ commit }) {
      commit('LOGIN_REQUEST');
    },

    receiveLogin({ commit }) {
      commit('LOGIN_SUCCESS');
    },
  },
};
